import { Component, Input, Output, EventEmitter } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { ExceptionInfo } from '../../../../models/session.model';

@Component({
  selector: 'app-session-exception-modal',
  standalone: true,
  imports: [CommonModule, CdkDrag, CdkDragHandle],
  template: `
    <div *ngIf="exception" cdkDrag
         class="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 bg-black border border-zaxis-border shadow-pixel rounded-none w-[600px] max-w-[90vw] z-[100] overflow-hidden flex flex-col">
      <div cdkDragHandle class="p-4 border-b border-zaxis-border bg-black flex justify-between items-center cursor-move">
        <h3 class="font-bold text-red-400 flex items-center gap-2">
          <i class="ph ph-warning-circle text-lg"></i>
          Exception Trace
        </h3>
        <button (click)="closed.emit()" class="text-gray-400 hover:text-white transition-colors">
          <i class="ph ph-x text-lg"></i>
        </button>
      </div>
      <div class="p-4 bg-black/60 max-h-[60vh] overflow-y-auto font-mono text-xs text-gray-300">
        <div class="mb-3 text-red-400 font-bold">{{ exception.exceptionName }}</div>
        <div class="mb-4 text-gray-400">{{ exception.exceptionMessage }}</div>
        <pre class="whitespace-pre-wrap leading-relaxed text-gray-500">{{ exception.stackTrace }}</pre>
      </div>
    </div>
  `
})
export class SessionExceptionModalComponent {
  @Input() exception: ExceptionInfo | null = null;
  @Output() closed = new EventEmitter<void>();
}
